/**
 * Come si scrive per chi legge una matricola che può mancare.
 *
 * Dal 03/11/2026 `devices.matricola` è nullable: una cassaforte entra in
 * magazzino prima che se ne conosca il seriale, e NULL vuol dire «non nota» —
 * mai un segnaposto. Un `{device.matricola}` in JSX non mostrerebbe niente, e
 * un `${device.matricola}` in un messaggio scriverebbe "null".
 *
 * Il backend ha la stessa etichetta in `utils/matricola.ts` (PDF e titoli dei
 * report): due lingue, come per le etichette degli enum dei dispositivi.
 */
export function etichettaMatricola(matricola: string | null): string {
  return matricola ?? "matricola non nota";
}
